import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getOrganizations } from './data';
import { errorReceiveOrganizations, failedReceiveOrganizations, receiveOrganizations } from './slice';
export function* requestOrganizations(action) {
    try {
        const { consumerAPI } = action.payload;
        const response = yield call(getOrganizations, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveOrganizations());
            }
            else if (data) {
                yield put(receiveOrganizations(data));
            }
            else {
                throw new Error(t('NO_ORGANIZATIONS_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveOrganizations());
            }
            else if (response && response.status === 200) {
                yield put(receiveOrganizations(response.data));
            }
            else {
                throw new Error(t('NO_ORGANIZATIONS_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveOrganizations());
    }
}
export function* watchRequestOrganizations() {
    yield takeLatest('organizations/requestOrganizations', requestOrganizations);
}
